
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { MaquininhaComponent } from './maquininha.component';
import { MaquininhaRoutingModule } from './maquininha-routing.module';
import { BandeirasModule } from 'src/app/components/bandeiras/bandeiras.module';
import { BannerTypeCModule } from 'src/app/components/banner-typec/banner-typec.module';
import { PromotionBannerModule } from 'src/app/components/promotion-banner/promotion-banner.module';
import { BlockTextModule } from 'src/app/components/block-text-img/block-text-img.module';
import { ButtonComponentModule } from 'src/app/components/button/button.module';


@NgModule({
    declarations: [
        MaquininhaComponent
    ],
    imports: [
        CommonModule,
        LazyLoadImageModule,
        MaquininhaRoutingModule,
        BandeirasModule,
        BannerTypeCModule, 
        PromotionBannerModule,
        BlockTextModule,
        ButtonComponentModule
    ]
})
export class MaquininhaModule { }


